export default __webpack_public_path__ + "static/media/Startup_Service2.b36378c9.mp4";